import { render, staticRenderFns } from "./AccountNotConfigured.vue?vue&type=template&id=a0dcf92e&scoped=true&"
import script from "./AccountNotConfigured.vue?vue&type=script&lang=js&"
export * from "./AccountNotConfigured.vue?vue&type=script&lang=js&"
import style0 from "./AccountNotConfigured.vue?vue&type=style&index=0&id=a0dcf92e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0dcf92e",
  null
  
)

export default component.exports